import { FRIENDLY_SERVER_ERROR_MESSAGE } from "./apiErrorMessage";

export async function parseApiResponseBody(response) {
  const text = await response.text();
  if (!text) return null;

  const contentType = response.headers.get("content-type") || "";
  const trimmed = text.trimStart().toLowerCase();
  if (
    contentType.includes("text/html") ||
    trimmed.startsWith("<!doctype") ||
    trimmed.startsWith("<html")
  ) {
    return {
      __htmlResponse: true,
      message: FRIENDLY_SERVER_ERROR_MESSAGE,
    };
  }

  try {
    const data = JSON.parse(text);
    if (data && typeof data.body === "string" && data.statusCode != null) {
      try {
        return JSON.parse(data.body);
      } catch {
        return data;
      }
    }
    return data;
  } catch {
    return {
      __htmlResponse: true,
      message: FRIENDLY_SERVER_ERROR_MESSAGE,
    };
  }
}

export function isHtmlApiResponse(response, parsedBody) {
  const contentType = response.headers.get("content-type") || "";
  if (contentType.includes("text/html")) {
    return true;
  }
  return Boolean(parsedBody?.__htmlResponse);
}
